export const THANK_YOU_TEXT =
  'Thank you for reaching out. I will get back to you as soon as possible'
export const MENU_LINKS = {
  HOME: 'ホーム',
  ABOUT: 'About',
  CONTACT: 'Contact',
}

export const VIDEO_ERROR_TEXT = 'Your browser doesn&lsquo;t support HTML5 video. Please visit our <a href="https://www.youtube.com/channel/UC9ey1O3A4d0N7esM-rySf7Q">Youtube page</a> instead.'

export const PREV_POST = 'Prev Post'
export const NEXT_POST = 'Next Post'
export const RELATED_ARTICLES_HEADER = '関連記事'

export const INVALID_EMAIL_ERROR = '入力内容が正しくありません。'
export const INVALID_KANJI_ERROR = '入力内容が正しくありません。'
export const INVALID_FURIGANA_ERROR = '入力内容が正しくありません。'
export const REQUIRED_FIELD_ERROR = '必須項目です。'
export const INVALID_JP_PHONE_NO = '入力内容が正しくありません。'
export const INVALID_NO_ERROR = 'Please enter a valid number.'

export const CATEGORY_SELECT_PLACEHOLDER = 'カテゴリの選択'
export const ENQUIRY_FIELD_LABEL = 'お問い合わせ内容'
export const KANJI_NAME_FIELD_LABEL = 'お名前'
export const FURIGANA_NAME_FIELD_LABEL = 'ふりがな'
export const EMAIL_FIELD_LABEL = 'メールアドレス'
export const EMAIL_FIELD_PLACEHOLDER = 'email@email.com'
export const PHONE_NO_FIELD_LABEL = '電話番号'
export const PHONE_NO_FIELD_PLACEHOLDER = '00-0000-0000'
export const CONTACT_SUBMIT_BTN_LABEL = '確認画面へ進む'
export const PRIVACY_POLICY_LABEL = 'プライバシーポリシー'
export const CONFIRM_CHECKBOX_LABEL = 'に同意します。'
export const PRIVACY_POLICY_CONFIRM_LABEL = 'プライバシーポリシーに同意します。'
export const NEWSLETTER_SUBSCRIBE_LABEL = 'ニュースレターの配信を希望する'
export const NEWSLETTER_SUBSCRIBE_BTN_LABEL = '登録する'
export const NEWSLETTER_SUBSCRIBE_THANK_YOU_MESSAGE = 'ニュースレター登録が完了しました。'

export const ARTICLE_FILTER_TRIGGER = '絞り込み'
export const RESET_FILTER_TEXT = 'すべて解除する'
export const RESET_FILTER_TEXT_ALT = 'すべてリセットする'
export const YEAR_FILTER_TITLE = '年'
export const CATEGORY_FILTER_TITLE = 'カテゴリー'
export const BRAND_FILTER_TITLE = 'ブランド'
export const GENRE_FILTER_TITLE = 'すべてのジャンル'

export const FACEBOOK_SHARE_LABEL = 'Share on Facebook'
export const TWITTER_SHARE_LABEL = 'Share on Twitter'
export const LINE_SHARE_LABEL = 'Share on LINE'
export const COPY_LINK_LABEL = 'Copy article link to clipboard'

export const FILTER_SHOW_ALL = 'すべて'
export const DEFAULT_PRODUCT_CTA_LABEL = 'View Details'
export const DEFAULT_LOAD_MORE_LABEL = 'Load More'

export const NO_ARTICLES_FOUND = '記事は見かけませんでした。'
export const COPIED_LINK_TEXT = 'URLがクリップボードにコピーされました。'
export const CONFIRM_COPY_TEXT = 'OK'

// New Mailchimp integration
export const CHOOSE_AN_OPTION = 'こちらからお選びください'
export const PARTNERSHIP_AND_LICENSING = 'MQAパートナー・ライセンスについて'
export const HARDWARE = 'ハードウェア'
export const STREAMING = 'ストリーミング・レコードレーベル・配信'
export const BROADCASTING = '放送'
export const APP = 'アプリ'
export const OTHER = 'その他'

export const PRESS_MEDIA = 'プレス・メディア関連'
export const USER_LISTENER = 'ユーザー・リスナー'

export const INTERESTED_LABEL = 'について知りたい'
export const COMPANY_NAME_LABEL = '会社名'
export const POSITION_LABEL = '職位'

export const CONFIRM_VIA_EMAIL_LABEL = 'ニュースレターご希望の方はこのチェックボックスをオンにしてください。'
